import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG } from 'src/app/core/services/app-config.service';
import { AppConfig } from '../models/config-variable.model';
import { Observable } from 'rxjs';
import { VariableValueDto } from '../dto/variable-value.dto';

@Injectable({
  providedIn: 'root',
})
export class VariableValueService {
	readonly ApiUrl:string = "/settings-value";
	readonly config: AppConfig=new AppConfig;

	constructor(private http: HttpClient, @Inject(APP_CONFIG) config: AppConfig) {
		this.config = config;
		this.ApiUrl = this.config.ApiUrl + this.ApiUrl;
	}

	public updateVariableValue( payload: VariableValueDto[] ): Observable<{ code: number; data: string }> {
		return this.http.put<{ code: number; data: string }>(this.ApiUrl, payload);
	}
}
